/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'lodash',
	'baglass/core-client/js/core-client/ui/properties/PropertyPageView',
	'../../nls/StringResources'
], function(_, PropertyPageView,StringResources) {
	'use strict';

	const LoggingConfigSlideout = PropertyPageView.extend({
		init(options) {
			LoggingConfigSlideout.inherited('init', this, arguments);
			_.extend(this, options);
			this.logger = this.glassContext.getCoreSvc('.Logger');
		},
		render() {
			this.$el.addClass('loggingConfigPane');
			const currentLogLevel = this.logger.getLevel();
			return this.renderPropertyUIControl({
				'ariaLabel': StringResources.get('loggingConfigurationSlideoutA11yLabel'),
				'glassContext': this.glassContext,
				'el': this.$el,
				'items': [{
					'value': StringResources.get('logging_congfig_title'),
					'type': 'Banner',
					'backButton': true,
					'centerLabel': true,
					'onClose': this._onClose.bind(this),
					'doClose': this._closeSlideout.bind(this)
				},{
					'type': 'HintText',
					'name': 'TypeInHintText',
					'visibility': 'visible',
					'label': StringResources.get('logging_config_description')
				},
				{
					'name': 'loggingConfigLoggingEnable',
					'checked': this.logger.isActive(),
					'label': StringResources.get('logging_active'),
					'type': 'ToggleButton'
				},{
					'type': 'Separator'
				},{
					'type': 'DropDown',
					'name': 'loggingConfigLogLevel',
					'label': StringResources.get('logging_level'),
					'options': [{
						'label': StringResources.get('log_level_Error'),
						'value': this.logger.logLevelEnum.error,
						'selected': this.logger.logLevelEnum.error === currentLogLevel
					}, {
						'label': StringResources.get('log_level_Warn'),
						'value': this.logger.logLevelEnum.warn,
						'selected': this.logger.logLevelEnum.warn === currentLogLevel

					}, {
						'label': StringResources.get('log_level_Info'),
						'value': this.logger.logLevelEnum.info,
						'selected': this.logger.logLevelEnum.info === currentLogLevel
					},{
						'label': StringResources.get('log_level_Debug'),
						'value': this.logger.logLevelEnum.debug,
						'selected': this.logger.logLevelEnum.debug === currentLogLevel
					}]
				}]
			});
		},
		_doSave() {
			const uiControl = this.getPropertyUIControl();
			const modifiedProps = uiControl.getModifiedProperties();
			const level = modifiedProps.loggingConfigLogLevel;
			const active = modifiedProps.loggingConfigLoggingEnable;

			this.logger.saveConfig(level, active);
		},
		_onClose() {
			this._doSave();
		},
		_closeSlideout() {
			this.slideout.hide();
		}
	});
	return LoggingConfigSlideout;
});
